import { v4 as uuidv4 } from 'uuid';
import type { LocalPhotoRef, PhotoContext } from '@/shared/capture/capture-session';

export interface CapturedPhotoAsset {
  capturedAt: string;
  height: number;
  mimeType: string;
  originalBlob: Blob;
  sha256?: string;
  thumbnailBlob: Blob;
  width: number;
}

export interface PhotoAssetInput {
  context: PhotoContext;
  registerId?: string;
  sessionId: string;
}

export function createPhotoRefFromAsset(input: PhotoAssetInput, asset: CapturedPhotoAsset): LocalPhotoRef {
  return {
    capturedAt: asset.capturedAt,
    context: input.context,
    height: asset.height,
    id: `photo-${uuidv4()}`,
    localBlobId: `blob-${uuidv4()}`,
    registerId: input.registerId,
    sessionId: input.sessionId,
    sha256: asset.sha256,
    sizeBytes: asset.originalBlob.size,
    thumbnailBlobId: asset.thumbnailBlob === asset.originalBlob ? undefined : `thumb-${uuidv4()}`,
    width: asset.width,
  };
}
